module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }